<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/storeCost/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button v-if="$checkBtnPermission('/storeCost/index', 'create')" size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button>
				</el-form-item>
				<el-form-item class="view-toggle" style="float: right">
					<el-button-group>
						<el-button size="small" :type="viewMode === 'card' ? 'primary' : 'default'" title="卡片视图" @click="toggleView('card')">
							<i class="el-icon-s-grid"></i>
						</el-button>
						<el-button size="small" :type="viewMode === 'list' ? 'primary' : 'default'" title="列表视图" @click="toggleView('list')">
							<i class="el-icon-s-unfold"></i>
						</el-button>
					</el-button-group>
				</el-form-item>
			</el-form>
			<!-- 列表视图 -->
			<STable v-if="viewMode === 'list'" :columns="columnsData" :data="listData" :loading="loading" border stripe @get-data="getListData"></STable>
			<!-- 卡片视图 -->
			<div v-else class="card-view">
				<div class="card-grid">
					<div v-for="(item, index) in listData" :key="index" class="card-item">
						<el-card class="cost-card" shadow="hover">
							<template #header>
								<div class="card-header">
									<span class="store-name">{{ item.storeName }}</span>
									<el-tag size="mini" effect="plain" class="header-tag">备用金</el-tag>
								</div>
							</template>
							<div class="card-body">
								<div class="balance-highlight">
									<span class="balance-label">备用金余额</span>
									<span class="balance-amount" v-money="item.remainingCost || 0">¥{{ item.remainingCost || 0 }}</span>
								</div>
								<div class="stat-row">
									<span class="label">总下发备用金</span>
									<span class="value" v-money="item.totalCost || 0">¥{{ item.totalCost || 0 }}</span>
								</div>
								<div class="stat-row">
									<span class="label">备用金总支出</span>
									<span class="value warning" v-money="item.totalExpense || 0">¥{{ item.totalExpense || 0 }}</span>
								</div>
								<div class="stat-row">
									<span class="label">创建人</span>
									<span class="value">{{ item.creator || "-" }}</span>
								</div>
								<div class="stat-row">
									<span class="label">创建时间</span>
									<span class="value time">{{ item.createTime || "-" }}</span>
								</div>
							</div>
						</el-card>
					</div>
				</div>
				<div v-if="listData.length === 0" class="empty-card">
					<el-empty description="暂无数据"></el-empty>
				</div>
			</div>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
	</div>
</template>

<script>
import { GetStoreCostMainPageList } from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import edit from "./edit.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "门店备用金"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			viewMode: "card", // 默认卡片视图
			listData: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: ""
			},
			storeList: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "120",
					align: "center"
				},
				{
					prop: "remainingCost",
					label: "备用金余额",
					minWidth: "100",
					align: "center",
					isMoney: true,
					moneyType: "income"
				},
				{
					prop: "totalCost",
					label: "总下发备用金",
					minWidth: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "totalExpense",
					label: "备用金总支出",
					align: "center",
					isMoney: true,
					moneyType: "expense"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "170",
					align: "center"
				}
			]
		};
	},
	// 注册组件
	components: {
		edit
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		//显示编辑界面
		handleEdit(row) {
			this.$refs.edit.editShow(row);
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetStoreCostMainPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 切换视图
		toggleView(mode) {
			this.viewMode = mode;
		}
	}
};
</script>

<style scoped>
.view-toggle {
	float: right;
}

.card-view {
	margin-top: 16px;
}

/* 一行五个，配合每页 10 条即为两行五列 */
.card-grid {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 16px;
}

.card-item {
	min-width: 0;
}

.cost-card {
	border-radius: 12px;
	overflow: hidden;
	transition: transform 0.25s ease, box-shadow 0.25s ease;
	border: 1px solid var(--app-border, #e7ebf3);
	box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);
}

.cost-card:hover {
	transform: translateY(-4px);
	box-shadow: 0 10px 28px rgba(29, 78, 216, 0.14);
}

.cost-card ::v-deep .el-card__header {
	padding: 12px 16px;
	background: linear-gradient(135deg, #eef4ff 0%, #f6f9ff 100%);
	border-bottom: 1px solid var(--app-border, #e7ebf3);
}

.cost-card ::v-deep .el-card__body {
	padding: 16px;
}

.card-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.store-name {
	font-size: 15px;
	font-weight: 600;
	color: #1e293b;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-right: 8px;
}

.header-tag {
	flex-shrink: 0;
	color: #1d4ed8;
	border-color: #bfd4ff;
	background: #eaf1ff;
}

.card-body {
	margin-bottom: 0;
}

/* 备用金余额突出展示区 */
.balance-highlight {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 16px 12px;
	margin-bottom: 12px;
	border-radius: 10px;
	background: linear-gradient(135deg, #1d4ed8 0%, #3b82f6 100%);
	box-shadow: 0 4px 12px rgba(29, 78, 216, 0.2);
}

.balance-label {
	font-size: 12px;
	color: rgba(255, 255, 255, 0.85);
	margin-bottom: 6px;
}

.balance-amount {
	font-size: 24px;
	font-weight: 700;
	color: #fff;
	line-height: 1.2;
	word-break: break-all;
	text-align: center;
}

.stat-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 0;
	border-bottom: 1px solid #f1f5f9;
}

.stat-row:last-child {
	border-bottom: none;
}

.stat-row .label {
	font-size: 13px;
	color: #64748b;
	flex-shrink: 0;
}

.stat-row .value {
	font-size: 14px;
	font-weight: 600;
	color: #334155;
	text-align: right;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-left: 8px;
}

.stat-row .value.warning {
	color: #d97706;
}

.stat-row .value.time {
	font-size: 12px;
	font-weight: 500;
	color: #94a3b8;
}

.empty-card {
	padding: 40px 0;
	text-align: center;
}

/* 窄屏自适应：保持每行数量随宽度合理降级 */
@media screen and (max-width: 1400px) {
	.card-grid {
		grid-template-columns: repeat(4, 1fr);
	}
}

@media screen and (max-width: 1100px) {
	.card-grid {
		grid-template-columns: repeat(3, 1fr);
	}
}

@media screen and (max-width: 768px) {
	.card-grid {
		grid-template-columns: repeat(2, 1fr);
	}
}
</style>
